@if (shouldShowMarkerSection()) {
  <section class="form-group markers-group" [ngClass]="{ 'empty': !hasMarkerSet }">
    @if (!hasMarkerSet) {
      <section>
        <button
          type="button"
          class="link-btn add-btn markers-btn"
          translate="activity-editor-new_markers"
          (click)="openMarkerSelectionModal()">
        </button>
      </section>
    } @else {
      <marker-set-panel
        class="first-auxiliary"
        [markerSet]="selectedMarkerSet"
        [activity]="activity"
        (onEdited)="handleMarkerSetEdited($event)"
        (onRemoved)="handleMarkerSetRemoved()">
      </marker-set-panel>
    }

  </section>
}
